function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 94"
}, props), React.createElement("path", {
  d: "M50.29 2C33.88 2 20.58 17.345 20.58 36.28c0 8.03 2.4 15.403 6.403 21.245L20.4 65.119l-2.206-2.546L3.929 79.034c-2.572 2.968-2.572 7.773 0 10.74 2.572 2.968 6.736 2.968 9.308 0l14.266-16.46-2.206-2.546 6.581-7.594c5.063 4.62 11.46 7.387 18.412 7.387C66.7 70.56 80 55.215 80 36.28 80 17.344 66.7 2 50.29 2z",
  stroke: "#357287",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));